import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import StudentListStudentName from './StudentListStudentName';
import StudentListSuccessScore from './StudentListSuccessScore';
import { StudentListStudent } from 'utils/types';
import { isEmpty } from 'lodash';
import Checkbox from '../SF/Checkbox';
import { getTenantConfig } from 'utils/tenant';
import { formatPhoneNumber } from 'utils/formatter';

export default class StudentListTableRow extends React.Component {

  get studentSelector() {
    return <Checkbox ariaLabel={"Select " + this.props.student.fullName}
                     checked={this.props.studentIsSelected}
                     value={this.props.student.id}
                     onChange={this.props.selectStudent} />
  }

  get studentName() {
    return <StudentListStudentName getStudentFolderLink={this.props.getStudentFolderLink}
                                   hasPhoto={this.props.student.hasPhoto}
                                   id={this.props.student.id}
                                   name={this.props.student.fullName}
                                   studentId={this.props.student.studentId}
                                   studentType={this.props.student.studentType}
                                   uuid={this.props.student.uuid}/>
  }

  get successScore() {
      if (!getTenantConfig('SUCCESS_SCORE_ENABLED')) return null;
      return <Table.Cell>
          <StudentListSuccessScore getSuccessScoreRange={this.props.getSuccessScoreRange} 
                                   studentId={this.props.student.id} 
                                   successScore={this.props.student.successScore} />
      </Table.Cell>
  }

  get email() {
    return isEmpty(this.props.student.email) ? '' : <a href={`mailto:${this.props.student.email}`}>{this.props.student.email}</a>
  }

  render () {
    return (
      <Table.Row>
        <Table.Cell>{this.studentSelector}</Table.Cell>
        <Table.Cell scope="row">{this.studentName}</Table.Cell>
        {this.successScore}
        <Table.Cell className='student-email'>{this.email}</Table.Cell>
        <Table.Cell className='student-phone'>{formatPhoneNumber(this.props.student.phone)}</Table.Cell>
        <Table.Cell className='student-cellphone'>{formatPhoneNumber(this.props.student.cellphone)}</Table.Cell>
      </Table.Row>
    )
  }

}

StudentListTableRow.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  getSuccessScoreRange: PropTypes.func.isRequired,
  selectStudent: PropTypes.func.isRequired,
  student: StudentListStudent.isRequired,
  studentIsSelected: PropTypes.bool.isRequired
};
